import {Link, LinkProps} from '@tanstack/react-router'
import {HTMLAttributes} from 'react'
import clsx from 'clsx'

type SubMenuItem = {
    className?: string
    id: string
    label: string
    to: LinkProps['to']
    params?: LinkProps['params']
    search?: LinkProps['search']
}

type SubMenuProps = HTMLAttributes<HTMLUListElement> & {
    className?: string
    onClose?: () => void
    items: SubMenuItem[]
}

const SubMenu = ({onClose, items, ...props}: SubMenuProps) => (
    <ul {...props} role="menubar">
        {items.map((item, index) => (
            <li role="menuitem" key={index}>
                <Link
                    to={item.to}
                    params={item.params}
                    search={item.search}
                    onClick={onClose}
                    className={clsx('inline-block', item.className)}
                >
                    {item.label}
                </Link>
            </li>
        ))}
    </ul>
)

export default SubMenu
